import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_SUBSCRIPTION_FLOW_QUERY_KEY } from "./useGetSubscriptionFlow";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  subscriptionId: string;
  email: string;
};

export const useStartChangeSubscriptionEmail = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionFlowApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.subscriptionFlowControllerStartReplaceEmail({
        id: params.subscriptionId,
        startEmailReplacementRequestOmitted: {
          email: params.email,
        },
      });
      queryClient.invalidateQueries({
        queryKey: [GET_SUBSCRIPTION_FLOW_QUERY_KEY],
      });
      onSuccess?.();

      return response;
    },
    onError: async (e) => {
      console.error(
        `Failed to start email change request in the subscription flow`,
        e
      );
      const error = await apiResponseErrorHandler(e);
      if (error.status === 409) {
        toast.error(
          "This email is already in use. Please double-check and try again."
        );
        return;
      }
      if (error.status === 401) {
        toast.error("You are not authorized to use this email.");
        return;
      }
      toast.error(
        `Error trying to start the change email subscription process. ${error.errors[0]}`
      );
    },
  });

  return mutation;
};
